<template>
	<button :class="getClasses" v-on="$listeners" :type="type">
		<span v-if="icon" :class="['icon', { 'is-small': small }]">
			<i v-if="!loading" :class="`fas ${icon}`"></i>
		</span>
		<span><slot/></span>
	</button>
</template>

<script>
export default {
	props: {
		info: {
			type: Boolean,
			default: true
		},

		light: {
			type: Boolean,
			default: false
		},

		small: {
			type: Boolean,
			default: false
		},

		loading: {
			type: Boolean,
			default: false
		},

		icon: {
			type: String,
			default: null
		},

		outlined: {
			type: Boolean,
			default: false
		},

		type: {
			type: String,
			default: 'button'
		}
	},

	computed: {
		getClasses() {
			return ['button', {
				'is-info': this.info,
				'is-light': this.light,
				'is-small': this.small,
				'is-loading': this.loading,
				'is-outlined': this.outlined
			}];
		}
	},

	methods: {

	}
};
</script>
